import { gql } from '@apollo/client';

export const QUESTIONNAIRE_TEMPLATE_FRAGMENT = gql`
  fragment QuestionnaireTemplateFragment on QuestionnaireTemplate {
    id
    title
    description
    questionnaireType
    createdTimestamp
    templateData
  }
`;
